import {useSearchParams} from "react-router";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {ExportDropdown} from "@/components/ExportDropdown/ExportDropdown.tsx";
import {MaintenanceStatusFilters} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/EventLogTable/components/EventLogFilters.tsx";

export const MaintenanceEventLogExport = () => {
  const {user, brand} = useCurrentUserContext();
  const [queryParams] = useSearchParams();

  if (!user?.has_write_access) {
    return null;
  }

  const filtersParam = queryParams.get("filters");
  let filters: Record<string, unknown>;
  try {
    filters = filtersParam ? JSON.parse(filtersParam) : {};
  } catch {
    filters = {};
  }

  if (!("types" in filters)) {
    filters.types = MaintenanceStatusFilters.map((filter) => filter.key);
  }

  const remainingParams = new URLSearchParams(queryParams);
  remainingParams.delete("filters");
  const params = remainingParams.toString();
  const filtersString = encodeURIComponent(JSON.stringify(filters));
  const baseUrl = `${brand.siteURL}/maintenance/audit-event-export?filters=${filtersString}${params ? `&${params}` : ""}`;

  return <ExportDropdown baseUrl={baseUrl} />;
};
